// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import ChoicesController from "./choices_controller"
application.register("choices", ChoicesController)

import FileDropController from "./file_drop_controller"
application.register("file-drop", FileDropController)

import DocumentExpirationController from "./document_expiration_controller"
application.register("document-expiration", DocumentExpirationController)

import FloatingTooltipController from "./floating_tooltip_controller"
application.register("floating-tooltip", FloatingTooltipController)

import FormattedNumberInputController from "./formatted_number_input_controller"
application.register("formatted-number-input", FormattedNumberInputController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import PaymentAllocationFormController from "./payment_allocation_form_controller"
application.register("payment-allocation-form", PaymentAllocationFormController)

import PollController from "./poll_controller"
application.register("poll", PollController)

import RowLinkController from "./row_link_controller"
application.register("row-link", RowLinkController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)
